import { useQuery } from '@tanstack/react-query';

import { User } from '@/model';
import { axiosInstance } from '@/service';
import { withZBSignature } from '@/service/zbSignature';
import { handleRegistrationRedirect } from '@/utility';

const key = ['REGISTER_USER'];

export const useRegister = (registerData: Partial<User>) => {
	return useQuery({
		queryKey: [...key, registerData],
		queryFn: async () => {
			const signedBody = await withZBSignature(registerData);

			const { data } = await axiosInstance.post(
				'auth/member/register',
				signedBody
			);

			if (data?.access_token) {
				await handleRegistrationRedirect(data);
			}

			return data;
		},
		enabled: Object.values(registerData).length > 0,
	});
};
